module.exports = __webpack_public_path__ + "static/media/listing-page-jaipur.0ea4d6bc.jpg";